export * from '@sportworld/js-sdk/src/constants/icons'

import { cdn } from '@sportworld/js-sdk/src/envs/envs'

import blockedIcon from '@/assets/icons/block-icon.svg'
import clear from '@/assets/icons/clear-symbol.svg'
import goal from '@/assets/icons/commentary/ic-goal.svg'
import redCard from '@/assets/icons/commentary/ic-red-card.svg'
import sync from '@/assets/icons/commentary/ic-sync.svg'
import yellowCard from '@/assets/icons/commentary/ic-yellow-card.svg'
import failIcon from '@/assets/icons/fail-icon.svg'
import infoIcon from '@/assets/icons/info-icon.svg'
import lockIcon from '@/assets/icons/lock-icon.svg'
import premiumStar from '@/assets/icons/premium-star.svg'
import search from '@/assets/icons/search.svg'
import specialHome from '@/assets/icons/special-home.svg'
import subscribedIcon from '@/assets/icons/subscribed-icon.svg'
import successIcon from '@/assets/icons/success-icon.svg'
import termsConditions from '@/assets/icons/terms-and-conditions.svg'
import favIconWhite from '@/assets/images/favicon_sportworld_white.svg'
import logoWhite from '@/assets/images/logo_sportworld_white.svg'

export const icons = {
  channelLogos: {
    bild: `${cdn}/icons/channel-logos/Bild_Logo.png`,
    dazn: `${cdn}/icons/channel-logos/Dazn_Logo.svg`,
    edge: `${cdn}/icons/channel-logos/Edge_Logo_light_RGB 1.png`,
    esl: `${cdn}/icons/channel-logos/Esl_Logo.svg`,
    eSports1: `${cdn}/icons/channel-logos/eSPORTS1_RGB_negativ 1.svg`,
    sport1Pluss: `${cdn}/icons/channel-logos/Logo_Sport1+_2013 1.svg`,
    moreThanTV: `${cdn}/icons/channel-logos/More_Than_Tv_Logo.png`,
    motorvision: `${cdn}/icons/channel-logos/Motorvision_Logo.svg`,
    sky: `${cdn}/icons/channel-logos/Sky_Sport_Logo_2020 2.svg`,
    sportDeutschland: `${cdn}/icons/channel-logos/Sport_Deutschland_Logo.svg`,
    sportDigtal: `${cdn}/icons/channel-logos/Sport-Digital 1.svg`,
  },
  navigation: {
    backArrow: `${cdn}/icons/navigation/back_arrow.svg`,
    broadcasters: `${cdn}/icons/navigation/broadcasters.svg`,
    calendar: `${cdn}/icons/navigation/calendar.svg`,
    cookie: `${cdn}/icons/navigation/cookie.svg`,
    gavel: `${cdn}/icons/navigation/gavel.svg`,
    house: `${cdn}/icons/navigation/house.svg`,
    idCard: `${cdn}/icons/navigation/id-card.svg`,
    lockAlt: `${cdn}/icons/navigation/lock-alt.svg`,
    profile: `${cdn}/icons/navigation/profile.svg`,
    settings: `${cdn}/icons/navigation/settings.svg`,
    sportsIcon: `${cdn}/icons/navigation/sports_icon.svg`,
    exit: `${cdn}/icons/navigation/exit.svg`,
    arrowRight: `${cdn}/icons/navigation/arrow_right.svg`,
    check: `${cdn}/icons/navigation/check.svg`,
    selected: `${cdn}/icons/navigation/selected.svg`,
    favorites: `${cdn}/icons/navigation/heart-outline.svg`,
    search,
    termsConditions,
    specialHome,
    premiumStar,
    lockIcon,
    blockedIcon,
    subscribedIcon,
    infoIcon,
  },
  sportCategory: {
    bike: {
      name: 'Motorsport',
      src: `${cdn}/icons/sport-categories/bike.svg`,
    },
    biking: {
      name: 'Radsport',
      src: `${cdn}/icons/sport-categories/biking.svg`,
    },
    boxingGlove: {
      name: 'Boxen',
      src: `${cdn}/icons/sport-categories/boxing-glove.svg`,
    },
    broom: {
      name: 'Funsport',
      src: `${cdn}/icons/sport-categories/broom.svg`,
    },
    dumbbell: {
      name: 'Leichtathletik',
      src: `${cdn}/icons/sport-categories/dumbbell.svg`,
    },
    footballHelmet: {
      name: 'Football',
      src: `${cdn}/icons/sport-categories/football-helmet.svg`,
    },
    futbol: {
      name: 'Fußball',
      src: `${cdn}/icons/sport-categories/futbol.svg`,
    },
    gamepad: {
      name: 'Esport',
      src: `${cdn}/icons/sport-categories/gamepad.svg`,
    },
    golfBall: {
      name: 'Golf',
      src: `${cdn}/icons/sport-categories/golf-ball.svg`,
    },
    heartbeat: {
      name: 'Fitness',
      src: `${cdn}/icons/sport-categories/heartbeat.svg`,
    },
    hockeySticks: {
      name: 'Eishockey',
      src: `${cdn}/icons/sport-categories/hockey-sticks.svg`,
    },
    racingCar: {
      name: 'Formel1',
      src: `${cdn}/icons/sport-categories/racing-car.svg`,
    },
    ski: {
      name: 'Wintersport',
      src: `${cdn}/icons/sport-categories/skiin.svg`,
    },
    tennisBall: {
      name: 'Tennis',
      src: `${cdn}/icons/sport-categories/tennis-ball.svg`,
    },
    handBall: {
      name: 'Handball',
      src: `${cdn}/icons/sport-categories/volleyball-ball.svg`,
    },
    volleyBall: {
      name: 'Volleyball',
      src: `${cdn}/icons/sport-categories/volleyball-ball.svg`,
    },
  },
  logoApp: {
    logoWhite,
  },
  controls: {
    play: `${cdn}/icons/controls/play.svg`,
    replay: `${cdn}/icons/controls/replay.svg`,
    pause: `${cdn}/icons/controls/pause.svg`,
    chevronUp: `${cdn}/icons/controls/chevron_up.svg`,
    chevronDown: `${cdn}/icons/controls/chevron_down.svg`,
  },
  slider: {
    playIcon: `${cdn}/icons/event-slider/ic-play-lane.svg`,
  },
  register: {
    loginIcon: `${cdn}/assets/login/login-icon.svg`,
    refreshIcon: `${cdn}/assets/login/refresh-icon.svg`,
    clockIcon: `${cdn}/assets/login/clock-icon.svg`,
    connectError: `${cdn}/assets/login/connect-error.svg`,
    doneIcon: `${cdn}/assets/login/done-icon.svg`,
    successIcon,
    failIcon,
    errorIcon: `${cdn}/assets/login/error-icon.svg`,
    lineConnect: `${cdn}/assets/login/line-connect.svg`,
    mobileImg: `${cdn}/assets/login/mobile-img.svg`,
    tvImg: `${cdn}/assets/login/sessionTV-img.svg`,
    qrMobileImg: `${cdn}/assets/login/mobile-img.png`,
    mobileAppImage: `${cdn}/assets/login/mobile-app.png`,
    promoRegisterImage: `${cdn}/assets/login/promo-img.png`,
    favIconWhite,
    appleIcon: `${cdn}/assets/login/apple-icon.svg`,
    googleIcon: `${cdn}/assets/login/google-icon.svg`,
    swCredits: `${cdn}/icons/credits/icon_sw_credits_new.svg`,
    swPromotionCredits: `${cdn}/icons/credits/icon_promotion_tokens.svg`,
  },
  welcome: {
    mobileAppImage: `${cdn}/assets/welcome/mobile-app.png`,
    voucherImage: `${cdn}/assets/welcome/WelcomeScreen_Promotion_Banner_Gutschein einlösen_V2.png`,
    voucherImageBefore2022: `${cdn}/assets/welcome/WelcomeScreen_Promotion_Banner_final_nicht22Devices.png`,
    appStoreImage: `${cdn}/assets/welcome/app-store.png`,
    googlePlayImage: `${cdn}/assets/welcome/google-play.png`,
  },
  favorites: {
    highlights: `${cdn}/icons/sport-categories/highlights.svg`,
    heart: `${cdn}/icons/navigation/heart.svg`,
    heartOutline: `${cdn}/icons/navigation/heart-outline.svg`,
  },
  keyboard: {
    clear,
  },
  commentary: {
    goal,
    redCard,
    sync,
    yellowCard,
  },
}

export const sliderItemImgPlaceholder =
  'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='

export const defaultBlockedBgImage = `${cdn}/assets/screen/channel_lock_screen.png`
export const stageGradient = `${cdn}/assets/general/home-gradient.svg`

export const creditsOptionEn = `${cdn}/assets/credits/credits-option-en.jpg`
export const creditsOptionDe = `${cdn}/assets/credits/credits-option-de.jpg`
